module.exports = require("node:perf_hooks");